export const isSponsorshipEnabled = partnercode => {
	const START = new Date("2020-02-20T00:00:00");
	const END = new Date("2020-03-19T23:59:59");
	const PARTNER_CODE_EK = "EKFR";
	const today = new Date();

	return today >= START && today < END && partnercode === PARTNER_CODE_EK;
};
